import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangPath } from "./hooks/useLangPath";
import Seo from "./Seo";

function NotFound() {
  const { t } = useTranslation();
  const langPath = useLangPath();

  return (
    <Container style={{ padding: "80px 16px", textAlign: "center" }}>
      <Seo
        title="Page Not Found — A.I. Trading Predictions"
        description="The page you are looking for does not exist."
        canonical="/404"
      />
      <h1 style={{ fontSize: "4rem", fontWeight: 700, color: "var(--heading)" }}>
        {t("common.notFound")}
      </h1>
      <p style={{ fontSize: 18, color: "var(--text-secondary)", marginBottom: 32 }}>
        {t("common.notFoundMessage")}
      </p>
      <Link to={langPath("/")} style={{ color: "var(--link)", fontWeight: 600 }}>
        {t("common.backToHome")}
      </Link>
    </Container>
  );
}

export default NotFound;
